import { css } from '@emotion/react';

import { COLORS } from '@/Client/Partials/CloseoutReviewFlow/closeoutTokens';

/**
 * The keyboard focus ring, in the panel's own ink rather than the browser's default blue.
 *
 * Every focusable thing in the grid wears this one, so a ring never reads as meaning something
 * particular to whatever it happens to be around. `:focus-visible` rather than `:focus` leaves it
 * to the browser to decide when a ring is wanted — which is on keyboard focus, not on a click.
 */
export const FOCUS_RING_STYLE = css`
  &:focus-visible {
    outline: 2px solid ${COLORS.ink};
    outline-offset: 1px;
  }
`;
